import { render, staticRenderFns } from "./StageAgeSelect.vue?vue&type=template&id=46a0cc80"
import script from "./StageAgeSelect.vue?vue&type=script&lang=js"
export * from "./StageAgeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports